import React, { useState } from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import {
	FormHeader,
	FormTitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	FormContainer,
	FormContent,
	Wrapper
} from '../../ui/form'
import { Button } from '../../ui/button'
import InputPassword from '../../inputPassword'
import { hideLoader, showLoader } from '../../../actions'
import { changeExistingPassword } from '../../../api/auth'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import Feedback from '../../feedback'
import { useDebouncedMatchValidation } from '../../../hooks/useDebouncedMatchValidation'

const ChangeUserPassword = ({ auth, dispatch }) => {
	const history = useHistory()
	const [currentPassword, setCurrentPassword] = useState('')
	const [newPassword, setNewPassword] = useState('')
	const [repeatPassword, setRepeatPassword] = useState('')
	const [loading, setLoading] = useState(false)
	const [isChanged, setIsChanged] = useState({ changed: false, error: false })

	const {
		error: repeatPasswordError,
		validateMatch: validateRepeatPassword,
		clearError: clearRepeatPasswordError
	} = useDebouncedMatchValidation({
		primaryValue: newPassword,
		secondaryValue: repeatPassword,
		requiredMessage: 'Repetí tu nueva contraseña',
		mismatchMessage: 'Las contraseñas no coinciden'
	})

	const handleSubmit = async e => {
		e.preventDefault()

		if (!validateRepeatPassword({ required: true })) {
			return
		}

		setLoading(true)
		dispatch(showLoader())

		const [err] = await to(changeExistingPassword(auth?.idUsuario, newPassword))

		if (err) {
			setLoading(false)
			setIsChanged({ changed: true, error: true })
			dispatch(hideLoader())
			return
		}

		setLoading(false)
		setIsChanged({ changed: true, error: false })
		dispatch(hideLoader())
	}

	const handleCancel = () => {
		history.push('/inicio/mis-datos')
	}

	return isChanged.changed ? (
		<Feedback
			title={
				!isChanged.error
					? 'Actualizamos tu contraseña'
					: 'Hubo un error al actualizar tu contraseña'
			}
			bodyText={
				!isChanged.error
					? 'Actualizamos tu contraseña con éxito'
					: 'Por favor volvé a intentarlo más tarde'
			}
			buttonLabel="Volver"
			onClickButton={handleCancel}
			isError={isChanged.error}
		/>
	) : (
		<Wrapper>
			<form onSubmit={handleSubmit}>
				<FormContainer justifyMobile="center" align="start" margin="0 0">
					<FormHeader align="start">
						<FormTitle>Cambiar contraseña</FormTitle>
					</FormHeader>
					<FormContent>
						<InputsContainer>
							<InputPassword
								label={'Contraseña actual'}
								placeholder={'Ingresa tu contraseña actual'}
								value={currentPassword}
								onChange={e => setCurrentPassword(e.target.value)}
							/>
							<InputPassword
								label={'Nueva contraseña'}
								placeholder={'Ingresa tu nueva contraseña'}
								value={newPassword}
								onChange={e => {
									setNewPassword(e.target.value)
									clearRepeatPasswordError()
								}}
							/>
							<InputPassword
								label={'Repetir contraseña'}
								placeholder={'Repite tu nueva contraseña'}
								value={repeatPassword}
								error={repeatPasswordError}
								onChange={e => {
									setRepeatPassword(e.target.value)
									clearRepeatPasswordError()
								}}
							/>
						</InputsContainer>
						<ButtonsContainer>
							<Button
								label={'Guardar cambios'}
								$variant="primary"
								size="mobile"
								type="submit"
								disabled={loading}
							/>
							<LinkButton type="button" onClick={handleCancel}>
								Cancelar
							</LinkButton>
						</ButtonsContainer>
					</FormContent>
				</FormContainer>
			</form>
		</Wrapper>
	)
}

const mapStateToProps = ({ auth }) => ({ auth })

export default connect(mapStateToProps)(ChangeUserPassword)
